import { render, staticRenderFns } from "./Trx.vue?vue&type=template&id=6a47aa2a&scoped=true"
import script from "./Trx.vue?vue&type=script&lang=js"
export * from "./Trx.vue?vue&type=script&lang=js"
import style0 from "./Trx.vue?vue&type=style&index=0&id=6a47aa2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a47aa2a",
  null
  
)

export default component.exports